import _ from 'lodash';

import { isDecoratorOption } from './components/DecoratorOption';
import { FilterTypes } from './FilterBaseCDS.constants';

export const getIsSelectedValues = ({
  isTextFilter,
  filterValues,
  isDateRangeFilter,
  isDateRangeSelected,
  selectedValues,
}) => {
  if (isTextFilter) {
    return !!filterValues;
  }

  if (isDateRangeFilter) {
    return isDateRangeSelected;
  }

  return !!selectedValues.length;
};

const getRegularOptionValues = selectOptions =>
  _.filter(
    selectOptions,
    ({ value, isExclusive, isSelectAll }) =>
      !isDecoratorOption(value) && !isExclusive && !isSelectAll,
  ).map(({ value }) => value);

const getSingleSelectNextValues = ({ prevValues, value, isClearable }) => {
  if (prevValues[0] !== value) {
    return [value];
  }

  return isClearable ? [] : prevValues;
};

export const getNextSelectedValues = ({
  prevValues,
  value,
  filterType,
  isClearable,
  selectOptions,
}) => {
  if (filterType === FilterTypes.SINGLE_SELECT) {
    return getSingleSelectNextValues({ prevValues, value, isClearable });
  }

  const option = _.find(selectOptions, { value });
  const exclusiveValue = _.find(selectOptions, 'isExclusive')?.value;

  if (option?.isExclusive) {
    return [value];
  }

  const getValuesOrExclusiveFallback = values =>
    values.length || isClearable || _.isNil(exclusiveValue) ? values : [exclusiveValue];

  if (option?.isSelectAll) {
    const regularValues = getRegularOptionValues(selectOptions);
    const isAllSelected = _.every(regularValues, regularValue =>
      _.includes(prevValues, regularValue),
    );

    return isAllSelected ? getValuesOrExclusiveFallback([]) : regularValues;
  }

  const prevSelectedValues = _.without(prevValues, exclusiveValue);

  return getValuesOrExclusiveFallback(
    _.includes(prevSelectedValues, value)
      ? _.without(prevSelectedValues, value)
      : [...prevSelectedValues, value],
  );
};

export const getSelectAllState = ({ selectedValues, selectOptions, filterType }) => {
  const regularValues =
    filterType === FilterTypes.MULTI_SELECT ? getRegularOptionValues(selectOptions) : [];
  const selectedCount = _.intersection(regularValues, selectedValues).length;
  const isChecked = !!regularValues.length && selectedCount === regularValues.length;

  return {
    isChecked,
    isIndeterminate: !!selectedCount && !isChecked,
  };
};

export const getSelectedOptionsLabel = ({ selectedValues, selectOptions, filterType }) => {
  const selectAllOption = _.find(selectOptions, 'isSelectAll');

  if (
    selectAllOption &&
    getSelectAllState({ selectedValues, selectOptions, filterType }).isChecked
  ) {
    return selectAllOption.label;
  }

  return _.filter(selectOptions, ({ value }) => _.includes(selectedValues, value))
    .map(({ label }) => label)
    .join(', ');
};
